export enum PaymentDiscriminatorEnum {
  DEPOSIT = 'DEPOSIT',
  BALANCE = 'BALANCE',
  PURCHASE = 'PURCHASE',
}
